import { Component, Injector, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { TierDto } from '../../../../../../../aumico-lib-users-fe/src/lib/dtos/organizationSearchDto.interface';
import { OrganizationProvider } from '../../../../../../../aumico-lib-users-fe/src/lib/provider/organisation.provider';
import { GetOrganizationDto } from '../../../../../../../aumico-lib-users-fe/src/public-api';
import { BasePageComponent } from '../../../../pages/base.page';

@UntilDestroy()
@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.page.html',
    styleUrls: ['./subscription.page.scss'],
})
export class SubscriptionPage extends BasePageComponent implements OnInit {
    showInfoDialog = false;
    showWelcomePopup: boolean = false;

    orgId: string;
    orgName: string;
    currentTierId: string;
    tierChanged: string;

    constructor(
        private injector: Injector,
        private organizationProvider: OrganizationProvider,
    ) {
        super(injector);

        this.organizationProvider.dispatchGetCurrentOrganization();
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.organizationProvider
            .getCurrentOrganization$()
            .pipe(
                filter((org: GetOrganizationDto) => org != null),
                untilDestroyed(this),
            )
            .subscribe((org) => {
                this.orgName = org.name;
                this.orgId = org.id;
                if (org.tier) {
                    console.log('Current organization tier:', org.tier);
                    if (this.currentTierId != null && this.currentTierId !== org.tier) {
                        console.log('new tier:', org.tier);
                        this.currentTierId = org.tier;

                        if (org.tier === TierDto.LIGHT) {
                            window.location.reload();
                            return;
                        }
                        this.showWelcomePopup = true;
                    } else {
                        this.currentTierId = org.tier;
                    }
                }
            });
    }

    onTierSwitch(newTier: string) {
        console.log('Switched to tier:', newTier);
        this.tierChanged = newTier;
        const tierEnum = Object.values(TierDto).find((tier) => tier === newTier) as TierDto;
        this.organizationProvider.dispatchUpdateOrganizationSubscription({
            id: this.orgId,
            tier: tierEnum,
        });

    }

    onContactSales() {
        this.bookCall();
    }

    bookCall() {
        window.open('https://meetings.hubspot.com/cbartosch/beratungsgespraech-aumico', '_blank');
    }

    closeWelcome(): void {
        this.showWelcomePopup = false;
        window.location.reload();
    }

    closeWelcomeAndStart(): void {
        this.showWelcomePopup = false;
        // open a link in a new tab
        window.open('https://meetings.hubspot.com/cbartosch/onboarding-mandats-und-aufgabenmanagement-abschlussprozess', '_blank');
        window.location.reload();
    }
}
